<template>
	<div class='grid-tr'>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>
				<a class='deal-name' :href='`/deals/${deal.id}/edit`'>
					<img :src='(deal.image_small)?(deal.image_small):("/assets/img/placeholder.png")'>
					<!-- <img src='/assets/img/hightQualityPhotoTest.png'> -->

					<span>
						{{deal.address}} | <span class='view-deal'>View Deal</span>
					</span>
				</a>
			</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>{{deal.units}}</div>

		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.total_revenues | formatUp2}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.piti | formatPrice}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.operation_expenses | formatPrice}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.cashflow | formatPrice}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.downpay_closing | formatPrice}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.repairs_renovation | formatPrice}}</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>{{deal.coc | formatPercentage}}%</div>
		</div>
		<div class='grid-td'>
			<div class='c-table-item c-myPortfolio__table__item'>$ {{deal.home_price | formatPrice}}</div>
		</div>
	</div>
</template>

<script>
import deal from '../mixins/deal';
export default {
	name:    'DealTable',
	mixins: [deal],
};
</script>
